if ($('.js-search').data('template') === 'compact') {
	if (!$.fn.velocity) {
		console.error('Search: Для работы формы необходимо подключить VelocityJS и VelocityJS UI Pack');
	}

	function headerSearch() {
		var $searchInput = $('.js-search-input');
		$searchInput
			.on('focus', function () {
				$(this).siblings('.search__label').hide();
				$('.js-search-message').velocity('transition.slideDownOut', 200);
			})
			.on('blur', function () {
				var $this = $(this);
				if ($this.val().length === 0){
					$this.siblings('.search__label').show();
				}
			});
	}

	function checkValLength(event) {
		var $this = $('.js-search-input');
		if ($this.val().length === 0) {
			event.preventDefault();
			$('.js-search-message').velocity('transition.slideUpIn', 200);
		}
	}

	$('.js-search').on('submit', checkValLength);

	headerSearch();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/search-form/compact/compact.js
 **/